import { render, staticRenderFns } from "./BaseBlurTabOverlay.vue?vue&type=template&id=35cb97cc&scoped=true"
import script from "./BaseBlurTabOverlay.vue?vue&type=script&lang=js"
export * from "./BaseBlurTabOverlay.vue?vue&type=script&lang=js"
import style0 from "./BaseBlurTabOverlay.vue?vue&type=style&index=0&id=35cb97cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb97cc",
  null
  
)

export default component.exports